import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { Style } from '@capacitor/status-bar';
import { AuthGuardService } from '@nsk-app/services/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full',
  },
  {
    path: 'welcome',
    loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomePageModule),
    data: {
      statusbarStyle: Style.Light
    }
  },
  {
    path: 'tutorial',
    loadChildren: () => import('./pages/tutorial/tutorial.module').then(m => m.TutorialPageModule),
    data: {
      statusbarStyle: Style.Dark
    }
  },
  {
    path: 'main',
    canActivate: [AuthGuardService],
    loadChildren: () => import('src/app/pages/main/main.module').then(m => m.MainPageModule),
    data: {
      statusbarStyle: Style.Dark
    }
  },
  {
    path: 'information-detail/:id',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./pages/information-detail/information-detail.module').then(m => m.InformationDetailPageModule),
    data: {
      statusbarStyle: Style.Dark
    }
  },
  {
    path: 'about',
    loadChildren: () => import('./pages/about/about.module').then( m => m.AboutPageModule),
    data: {
      statusbarStyle: Style.Dark
    }
  },
  {
    path: 'privacy',
    loadChildren: () => import('./pages/privacy/privacy.module').then( m => m.PrivacyPageModule),
    data: {
      statusbarStyle: Style.Dark
    }
  },
  {
    path: 'imprint',
    loadChildren: () => import('./pages/imprint/imprint.module').then( m => m.ImprintPageModule),
    data: {
      statusbarStyle: Style.Dark
    }
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules, useHash: true})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
